<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue';
  import { VueFinalModal } from 'vue-final-modal';
  import { UiModalHeader, ColoredButton } from '@/shared/ui';
  import PositionFormContent from './PositionFormContent.vue';
  import { useDepartmentOptions } from '../lib';

  defineProps<{
    title?: string;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'save', data: { position: string; departmentId: number }): void;
  }>();

  const position = ref('');
  const departmentId = ref<string>('');

  const {
    departmentOptions,
    isLoading: isLoadingDepartments,
    loadDepartments,
    handleSearch,
  } = useDepartmentOptions();

  const isFormValid = computed(() => {
    return !!position.value.trim() && !!departmentId.value;
  });

  onMounted(() => {
    loadDepartments();
  });

  const handleClose = () => {
    emit('close');
  };

  const handleSave = () => {
    if (!isFormValid.value) return;

    emit('save', {
      position: position.value,
      departmentId: Number(departmentId.value),
    });
  };

  const handleClosed = () => {
    position.value = '';
    departmentId.value = '';
  };
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl w-[900px] shadow-lg"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    @closed="handleClosed"
  >
    <div class="overflow-visible flex flex-col">
      <UiModalHeader
        class="px-6 py-4 text-sm border-b border-gray-02 flex-shrink-0"
        :title="title || 'Novo Cargo'"
        @close="handleClose"
      />

      <PositionFormContent
        :position="position"
        :department-id="departmentId"
        :department-options="departmentOptions"
        :department-loading="isLoadingDepartments"
        :max-length-label="true"
        @update:position="position = $event"
        @update:department-id="departmentId = $event"
        @department-search="handleSearch"
      />

      <div class="px-6 py-8 flex justify-end gap-3 border-t border-gray-02 flex-shrink-0">
        <ColoredButton
          text="Cancelar"
          outlined
          color="gray-03"
          @click="handleClose"
        />
        <ColoredButton
          :disabled="!isFormValid"
          text="Salvar"
          @click="handleSave"
        />
      </div>
    </div>
  </VueFinalModal>
</template>

<style scoped>
  .vfm__overlay {
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
